import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  initialize() {
    this.timeout = null
  }

  submitForm(event) {
    event.preventDefault();
    this.formTarget.submit();
  }
  
  search(event) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      event.target.form.requestSubmit()
    }, 200)
  }

  connect() {
    this.selectTargets.forEach((select) => {
      select.addEventListener("change", this.search.bind(this))

      const choicesEnabled = select.getAttribute("data-choices")
      if (choicesEnabled === "true") {
        new Choices(select)
      }
    })
    document.addEventListener('turbo:frame-load', function(event) {
      if (event.target.id === 'courses') {
        var count_elements = document.querySelectorAll("div.filtered_course").length;
        document.getElementById("total_courses").textContent = count_elements;
      }
    });
  }

  disconnect() {
    this.selectTargets.forEach((select) => {
      select.removeEventListener("change", this.search.bind(this))
    })
  }
}

